import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../Pages/Login";
import Dashboard from "../Pages/Dashboard";
import SupplierDetail from "../Pages/Tabs/SupplierDetail";
import RoutingGuideDetail from "../Pages/Tabs/RoutingGuideDetail";
import ExceptionPoDetail from "../Pages/Tabs/ExceptionPoDetail";
import { LoginContext } from "../Pages/LoginContext";
import LoadingSpinner from "../Components/Loder";
import UnauthorizedPage from "../Pages/Unathorizedpage";
import Pagenotfound from "../Pages/Pagenotfound";

function AppRoutes() {
  const { userRole, loading } = useContext(LoginContext);

  if (loading) {
    return <LoadingSpinner />;
  }

  // Check if user has an invalid role
  if (userRole && !["admin", "vendor", "preticket"].includes(userRole)) {
    return <UnauthorizedPage />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route
        path="/"
        element={
          userRole ? (
            <Navigate
              to={
                userRole === "preticket"
                  ? "/dashboard/pre-ticket"
                  : "/dashboard/codes-and-facilities"
              }
              replace
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {userRole === "admin" ? (
        <>
          <Route
            path="/dashboard/codes-and-facilities"
            element={<Dashboard value={"codes-and-facilities"} />}
          />
          <Route
            path="/dashboard/vendors"
            element={<Dashboard value={"vendors"} />}
          />
          <Route
            path="/dashboard/exceptions"
            element={<Dashboard value={"exceptions"} />}
          />
          <Route
            path="/dashboard/vendors/:supplierSiteId"
            element={
              <>
                <Dashboard value={"supplier-details"} />
                <SupplierDetail />
              </>
            }
          />
          <Route
            path="/dashboard/routing-guides/:routing_guide_id"
            element={
              <>
                <Dashboard value={"supplier-details"} />
                <RoutingGuideDetail />
              </>
            }
          />
          <Route
            path="/dashboard/routing-guides"
            element={<Dashboard value={"routing-guides"} />}
          />
          <Route
            path="/dashboard/pre-ticket"
            element={<Dashboard value={"pre-ticket"} />}
          />
          <Route
            path="/exceptions/:poExceptionId"
            element={
              <>
                <Dashboard value={"PoNumber-details"} />
                <ExceptionPoDetail />
              </>
            }
          />
        </>
      ) : userRole === "vendor" ? (
        <>
          <Route
            path="/dashboard/exceptions"
            element={<Dashboard value={"exceptions"} />}
          />
          <Route
            path="/exceptions/:poExceptionId"
            element={
              <>
                <Dashboard value={"PoNumber-details"} />
                <ExceptionPoDetail />
              </>
            }
          />
          <Route
            path="/dashboard/*"
            element={<Navigate to="/dashboard/exceptions" replace />}
          />
        </>
      ) : userRole === "preticket" ? (
        <>
          <Route
            path="/dashboard/pre-ticket"
            element={<Dashboard value={"pre-ticket"} />}
          />
          <Route
            path="/dashboard/*"
            element={<Navigate to="/dashboard/pre-ticket" replace />}
          />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/unauthorized" replace />} />
      )}

      <Route path="*" element={<Pagenotfound />} />
    </Routes>
  );
}

export default AppRoutes;
